document.addEventListener('DOMContentLoaded', function () {
    const tabButtons = document.querySelectorAll('.discover-app__tab-button');

    tabButtons.forEach((button) => {
        button.addEventListener('click', function () {
            const tabId = this.getAttribute('data-tab');
            const parentTabs = this.closest('.discover-app__tabs');

            parentTabs.querySelectorAll('.discover-app__tab-button').forEach((btn) => {
                btn.classList.remove('active');
            });

            parentTabs.querySelectorAll('.discover-app__tab-content').forEach((content) => {
                content.classList.remove('active');
            });

            this.classList.add('active');

            document.getElementById(tabId).classList.add('active');
        });
    });
});